import { forwardRef, cloneElement, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useSpring, animated } from "@react-spring/web";
import OutlinedTextField from "./OutlinedTextField";
import CustomizedButton from "./CustomizedButton";
import FormHelperText from "@mui/material/FormHelperText";
import config from "../config";

const Fade = forwardRef(function Fade(props, ref) {
    const { children, in: open, onClick, onEnter, onExited, ownerState, ...other } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter(null, true);
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited(null, true);
            }
        },
    });

    return (
        <animated.div ref={ref} style={style} {...other}>
            {cloneElement(children, { onClick })}
        </animated.div>
    );
});

Fade.propTypes = {
    children: PropTypes.element.isRequired,
    in: PropTypes.bool,
    onClick: PropTypes.any,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
    ownerState: PropTypes.any,
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    width: 560,
    bgcolor: "black",
    border: "1px solid white",
    boxShadow: 24,
    p: 4,
};

export default function PasswordChange({
    openPwModal,
    handlePwOpen,
    handlePwClose,
    setPasswordSearch,
    setPw,
    pw,
    passwordChangeEmail,
    label,
    handleCloseAll,
    password,
}) {
    const [open, setOpen] = useState(openPwModal);
    const [newPw, setNewPw] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [email, setEmail] = useState(window.sessionStorage.getItem("id"));
    if (email === null) {
        setEmail(passwordChangeEmail);
    }
    const handleClose2 = () => {
        setPasswordSearch(false);
        handlePwClose();
        setOpen(false);
        if (label === "forgot-password") {
            handleCloseAll();
        }
    };

    const isValidPassword = (password) => {
        const passwordRegex = password.length >= 4 && password.length <= 20;
        return passwordRegex;
    };
    const handlePwUpdate = (e) => {
        if (isValidPassword(newPw)) {
            axios
                .post(`${config.API_URL}/passwordUpdate`, {
                    member_id: email,
                    member_pw: newPw,
                })
                .then((res) => {
                    if (res.data === 1) {
                        handleClose2();
                        if (label === "Change Password") {
                            if (pw === newPw) {
                                alert("This is the same password!");
                            } else {
                                alert("Password updated successfully!");
                            }
                            setPw(newPw);
                        } else {
                            if (password === newPw) {
                                alert("This is the same password!");
                            } else {
                                alert("Password updated successfully!");
                            }
                            setPw(newPw);
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        } else if (newPw === "") {
            setPasswordError("Please enter your password.");
        }
    };

    const checkenterSubmit = (e) => {
        if (e.key === "Enter") {
            handlePwUpdate();
        }
    };

    return (
        <div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={open}
                onClose={handleClose2}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography
                            sx={{ textAlign: "center", mx: "auto", mb: 3 }}
                            id="spring-modal-title"
                            variant="h5"
                            component="h2"
                        >
                            Change Password
                        </Typography>
                        <Box sx={{ display: "flex" }}>
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Enter Password
                            </Typography>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <OutlinedTextField
                                    value={newPw}
                                    onChange={setNewPw}
                                    isValidPassword={isValidPassword}
                                    setPasswordError={setPasswordError}
                                    label="Enter new password"
                                    onKeyPress={checkenterSubmit}
                                />
                                <FormHelperText sx={{ mt: -2, fontSize: "1em", color: "red" }}>
                                    {passwordError}
                                </FormHelperText>
                            </Box>
                        </Box>

                        <Box sx={{ ml: 60 }}>
                            <CustomizedButton
                                label="Confirm"
                                value="updateDelete"
                                onClick={handlePwUpdate}
                            ></CustomizedButton>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
